import { faLayerGroup, faRepeat } from '@fortawesome/free-solid-svg-icons';
import { Spacer } from '@ui';
import { FormInput } from 'components/Form/next';
import { useTranslation } from 'react-i18next';

interface Props {
    name: string;
}

export const RepeatingTypeSelect = ({ name }: Props) => {
    const { t } = useTranslation('bookings');

    return (
        <>
            <Spacer />
            <FormInput.OptionCards
                name={name}
                ariaLabel={t('event.form.recurringSectionTitle')}
                options={[
                    {
                        value: 'single',
                        icon: faRepeat,
                        label: t('event.form.repeatingTypeSelect.singleLabel'),
                        description: t('event.form.repeatingTypeSelect.singleDescription')
                    },
                    {
                        value: 'multi',
                        icon: faLayerGroup,
                        label: t('event.form.repeatingTypeSelect.multiLabel'),
                        description: t('event.form.repeatingTypeSelect.multiDescription')
                    }
                ]}
            />
            <Spacer />
        </>
    );
};
